// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandhub-sub-navigation-item{opacity:0;pointer-events:none;transform:translateY(2.1428571429rem);transition:transform .4s ease-out,opacity .8s ease-out}.brandhub-sub-navigation-item--in{opacity:1;pointer-events:auto;transform:translateY(0)}.brandhub-sub-navigation-item--edit-mode .new{height:2.875rem;min-width:8rem}", ""]);
// Exports
module.exports = exports;
